import React from 'react';

import PropTypes from 'prop-types';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import TextField from '@mui/material/TextField';


const disableSundayFunc = (date) => {
    return date.getDay() === 0;
};


const MyOldDatePicker = ({ label, value, onChange, required, disableSunday, disableFuture, disablePast, ...rest }) => {

    return (

        <DatePicker
            label={label}
            value={value}
            onChange={onChange}
            renderInput={(params) => <TextField {...params} required={required} {...rest} />}

            InputAdornmentProps={{ position: "start" }}

            cancelText={"Annuler"}
            okText={"Valider"}
            todayText={"Aujourd'hui"}
            clearText={"Effacer"}
            showTodayButton
            showDaysOutsideCurrentMonth={true}
            disableOpenPicker={false}
            clearable={!required}

            shouldDisableDate={disableSunday ? disableSundayFunc : () => { return false; }}

            disableFuture={disableFuture}
            disablePast={disablePast}

        /> 
        );
};



MyOldDatePicker.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.object,
    onChange: PropTypes.func.isRequired,

    required: PropTypes.bool,
    disableFuture: PropTypes.bool,
    disablePast: PropTypes.bool,
    disableSunday: PropTypes.bool
};


MyOldDatePicker.defaultProps = {
    value: '',
    required: false,
    disableFuture: false,
    disablePast: false,
    disableSunday: false,
};

export default MyOldDatePicker;
